import { Link, NavLink } from "react-router-dom";
import ImgGramInfoPage from "./ImgGramInfoPage";

const Shala = () => {
    return (
        <div className="max-w-5xl mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-6 text-left"> 
               शाळेची माहिती
            </h1>
            <div className="h-0.5 w-full bg-orange-500 mb-6"></div>

            <p className="text-gray-700 mb-4 text-left">
                जिल्हा परिषद आदर्श प्राथमिक शाळ चांडोली खुर्द शाळेची  स्थापना 24/4/1988 साली झाली. इयत्ता पहिली ते सातवी पर्यंतचे  वर्ग असणारी अशी ही जिल्हा परिषद शाळा.आज शाळेमध्ये पहिली ते  सातवी पर्यतचे वर्ग  असून १२७ मुले शिक्षण घेत आहेत. व ६ शिक्षक अध्यापनाचे कार्य करत आहे. अडिच एकर क्षेत्रात दोन  इमारती असणारी RCC बांधकामाची  शाळा आहे. मुख्याध्यापक कक्ष  व संगणक कक्षासह व सात वर्ग यासाठी  एकूण ९ खोल्या आहेत.  इमारत भक्कम व पक्की आहे.शाळेत रेन वॉटर हार्वेस्टीग युनिट  बसवलेले आहे. RCC बांध‌कामाचे मुलांना पुरेसे असे शौचालय व हॅन्ड़वॉश स्टेशन आहे. मुलांना पिण्याच्या पाण्यासाठी  RO plant आहे. 24 तास स्वच्छ व शुद्ध पाणी उपलब्ध आहे. शाळेच्या सर्व वर्ग खोल्यांमध्ये स्मार्ट १० TVबसवलेले आहेत. व यांचा नियमित वापर होतो तसेच संगणक कक्ष व  विज्ञान प्रयोगशाळा  उपलब्ध आहे.शाळेत Room to read या उपक्रमांतर्गत वाचनालय सुरु आहे .शाळेत शेजारी  परसबाग केलेली आहे. व शाळेभोवती वृक्ष लागवड केलेली आहे.शाळेला प्रशस्त मैदान आहेत. मुलांना खेळाचे साहित्य दिले जाते. या वर्षी शिष्यवृत्ती परीक्षेसाठी इ. ४ थी ,५ वी, व ७ वी चे विद्यार्थी आहेत .इतरही खाजगी परीक्षांसाठी  विद्यार्थी बसवले जातात. दरवर्षी राज्य, जिल्हा, केंद्र गुणवत्ता  यादीत विद्यार्थी झळकतात. यावर्षी एक विद्यार्थी सैनिकी स्कूल सारी पात्र ठरला आहे.शाळेत सर्व सह शालेय उपक्रम घेतले जातात. आनंददायी शनिवार  या उपक्रमांतर्गत रांगोळी काढणे, कागदकाम , गणपती रंगवणे,सांस्कृतिक कार्यक्रम  असे उपक्रम राबविले जातात.
                पंचायत समिती सुपर २३ यासाठी ७ वी चा  एक विद्यार्थी पात्र ठरला आहे.
                आजपर्यंत एकूण ९३ विद्यार्थी शिष्यवृत्ती  धारक झाले आहेत. अशी आमची सर्वगुणसंपन्न व उपक्रमशील अशी आदर्श प्राथमिक शाळा आहे. 
            </p>

            {/* <ImgGramInfoPage />
            <NavLink
                to="/grampanchayatinfo"
                className="bg-orange-500 text-black rounded px-3 py-2 hover:bg-orange-600"
            >
                अधिक वाचा ...
            </NavLink> */}
        </div>
    );
}


export default Shala;